import { useUsers } from '~/api/queries/user'
import { useOffersAutocomplete } from '~/domains/offers/queries/useOffersAutocomplete'

export const OfferChipValue = ({ id }: { id: string }) => {
  const { data: users } = useUsers()
  const userIds = users?.map((user) => user.id) ?? []
  const { data } = useOffersAutocomplete({
    userIds,
    ids: [Number.parseInt(id, 10)]
  })
  const title = data?.pages[0]?.['hydra:member']?.[0]?.title
  return title ?? null
}
